module.exports = __webpack_public_path__ + "img/new_4.4b45b677.jpeg";